import Checkbox from './_checkbox';

export default Checkbox;
